import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { FormBuilder, FormGroup, FormsModule } from '@angular/forms';
import { TabsInnerWrapComponent } from '../../components/tabs-inner-wrap/tabs-inner-wrap.component';
import { OverallSectionComponent } from './overall-section/overall-section.component';
import { MessagingSectionComponent } from './messaging-section/messaging-section.component';
import { MethodologySectionComponent } from './methodology-section/methodology-section.component';
import { SkillSectionComponent } from './skills-section/skill-section.component';
import { AuthorReactiveFormService } from '../../services/author-reactive-form.service';
import { ActivatedRoute } from '@angular/router';
import { SimulationConstants } from 'src/app/utils/constants/self-serve/simulation.constants';
import { debounceTime, distinctUntilChanged } from 'rxjs';
import { IScoreWeight } from 'src/app/interfaces/self-serve/isimulation-score';

@Component({
  selector: 'tab-scoring-details',
  standalone: true,
  templateUrl: './scoring-details.component.html',
  styleUrls: ['./scoring-details.component.scss'],
  imports: [
    FormsModule,
    CommonModule,
    TabsInnerWrapComponent,
    OverallSectionComponent,
    MessagingSectionComponent,
    MethodologySectionComponent,
    SkillSectionComponent,
  ],
})
export class ScoringDetailsComponent {
  form!: FormGroup;
  formWeightSection!: FormGroup;

  callUuid: string = '';

  skillsDisabled: boolean = false;
  methodolgyDisabled: boolean = false;
  messagingDisabled: boolean = false;

  constructor(
    private authorReactiveFormService: AuthorReactiveFormService,
    private fb: FormBuilder,
    private route: ActivatedRoute
  ) {}

  ngOnInit(): void {
    this.callUuid = this.route.snapshot.paramMap.get('uuid') ?? '';
    if (this.callUuid) {
      this.initializeForm();
    }
  }

  private initializeForm(): void {
    this.authorReactiveFormService.getForm(this.callUuid).subscribe((form) => {
      this.form = form?.get(SimulationConstants.SCORING_SECTION) as FormGroup;
      this.formWeightSection = this.form?.get(
        SimulationConstants.SCORING_WEIGHTS_SECTION
      ) as FormGroup;

      if (this.formWeightSection) {
        this.setupWeightValueChange(this.formWeightSection);
        this.updateSectionDisableStates(this.formWeightSection.value);
      }
    });
  }

  private setupWeightValueChange(section: FormGroup): void {
    section.valueChanges
      .pipe(
        debounceTime(SimulationConstants.AUTOSAVE_GENERIC_DEBOUNCE),
        distinctUntilChanged((a, b) => JSON.stringify(a) === JSON.stringify(b))
      )
      .subscribe((updatedValue: IScoreWeight[]) => {
        console.log('Updated value in scoring details', updatedValue);
        this.updateSectionDisableStates(updatedValue);
      });
  }

  private updateSectionDisableStates(formWeightValue: IScoreWeight[]) {
    formWeightValue.forEach((item: { section: any; disabled: boolean }) => {
      switch (item.section) {
        case 'Methodology':
          this.methodolgyDisabled = item.disabled;
          break;
        case 'Messaging':
          this.messagingDisabled = item.disabled;
          break;
        case 'Skills':
          this.skillsDisabled = item.disabled;
          break;
      }
    });
  }
}
